// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { BasicEnrollmentPatient } from './basicEnrollmentPatient.js';
import type { BasicEnrollmentPaymentType } from './basicEnrollmentPaymentType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BasicExpressEnrollmentRequest {
    'patient': BasicEnrollmentPatient | null;
    'enrollmentPaymentType'?: BasicEnrollmentPaymentType;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BasicExpressEnrollmentRequest>> = [
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "BasicEnrollmentPatient"
        },
        {
            "name":     "enrollmentPaymentType",
            "baseName": "enrollmentPaymentType",
            "type":     "BasicEnrollmentPaymentType"
        },
    ];

    static getAttributeTypeMap() {
        return BasicExpressEnrollmentRequest.attributeTypeMap;
    }
}
